var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"definition"},[_vm._v(_vm._s(`${_vm.data.definition}`))]),_c('span',{staticClass:"dictionary-name"},[_vm._v(_vm._s(_vm.data.dictionaryName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }